import React from "react";
import { X } from "lucide-react";

export default function LanguageModal({
  isOpen = true,
  onClose,
  selectedLanguage = "en",
  onSelectLanguage,
}) {
  if (!isOpen) return null;

  const handleSelect = (lang) => {
    onSelectLanguage?.(lang);
  };

  return (
    <>
      <div className="lgm-overlay" onClick={onClose}>
        <div
          className="lgm-modal"
          onClick={(e) => e.stopPropagation()}
          role="dialog"
          aria-modal="true"
          aria-label="Region language"
        >
          <div className="lgm-header">
            <h2 className="lgm-title">Region Language</h2>

            <button
              type="button"
              className="lgm-close-btn"
              onClick={onClose}
              aria-label="Close modal"
            >
              <X size={30} strokeWidth={2.4} />
            </button>
          </div>

          <div className="lgm-body">
            <button
              type="button"
              className={`lgm-lang-card ${
                selectedLanguage === "en" ? "lgm-active" : ""
              }`}
              onClick={() => handleSelect("en")}
            >
              <span className="lgm-flag lgm-flag-uk" aria-hidden="true">
                <span className="lgm-uk-base" />
                <span className="lgm-uk-white-h" />
                <span className="lgm-uk-white-v" />
                <span className="lgm-uk-red-h" />
                <span className="lgm-uk-red-v" />
                <span className="lgm-uk-white-d1" />
                <span className="lgm-uk-white-d2" />
                <span className="lgm-uk-red-d1" />
                <span className="lgm-uk-red-d2" />
              </span>
              <span className="lgm-lang-text">English</span>
            </button>

            <button
              type="button"
              className={`lgm-lang-card ${
                selectedLanguage === "bn" ? "lgm-active" : ""
              }`}
              onClick={() => handleSelect("bn")}
            >
              <span className="lgm-flag lgm-flag-bd" aria-hidden="true">
                <span className="lgm-bd-base" />
                <span className="lgm-bd-circle" />
              </span>
              <span className="lgm-lang-text">বাংলা</span>
            </button>
          </div>
        </div>
      </div>

      <style>{`
        * {
          box-sizing: border-box;
        }

        .lgm-overlay {
          position: fixed;
          inset: 0;
          z-index: 9999;
          background: rgba(0, 0, 0, 0.55);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 18px;
          backdrop-filter: blur(2px);
          -webkit-backdrop-filter: blur(2px);
        }

        .lgm-modal {
          width: 100%;
          max-width: 520px;
          background: #353168;
          border: 2px solid #726dd2;
          border-radius: 28px;
          border-bottom-left-radius: 0;
          box-shadow: 0 18px 48px rgba(0, 0, 0, 0.45);
          overflow: hidden;
        }

        .lgm-header {
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 18px 0 18px;
        }

        .lgm-title {
          margin: 0;
          color: #ffc20a;
          font-size: 15px;
          line-height: 1;
          font-weight: 700;
        }

        .lgm-close-btn {
          width: 28px;
          height: 28px;
          border: 0;
          background: transparent;
          color: #ffc20a;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          padding: 0;
        }

        .lgm-body {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 50px;
          padding: 46px 24px 42px;
        }

        .lgm-lang-card {
          border: 0;
          background: transparent;
          color: #ffffff;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 14px;
          cursor: pointer;
          padding: 0;
          opacity: 0.95;
        }

        .lgm-lang-card.lgm-active {
          opacity: 1;
        }

        .lgm-flag {
          width: 55px;
          height: 55px;
          border-radius: 50%;
          position: relative;
          overflow: hidden;
          display: block;
          box-shadow:
            inset 0 6px 10px rgba(255, 255, 255, 0.18),
            inset 0 -8px 10px rgba(0, 0, 0, 0.22),
            0 4px 10px rgba(0, 0, 0, 0.18);
        }

        /* UK Flag */
        .lgm-flag-uk {
          background: #1e3c92;
        }

        .lgm-uk-base,
        .lgm-uk-white-h,
        .lgm-uk-white-v,
        .lgm-uk-red-h,
        .lgm-uk-red-v,
        .lgm-uk-white-d1,
        .lgm-uk-white-d2,
        .lgm-uk-red-d1,
        .lgm-uk-red-d2 {
          position: absolute;
          inset: 0;
        }

        .lgm-uk-base {
          background: #193f91;
        }

        .lgm-uk-white-h {
          top: 50%;
          left: 0;
          right: 0;
          height: 18px;
          transform: translateY(-50%);
          background: #ffffff;
        }

        .lgm-uk-white-v {
          left: 50%;
          top: 0;
          bottom: 0;
          width: 18px;
          transform: translateX(-50%);
          background: #ffffff;
        }

        .lgm-uk-red-h {
          top: 50%;
          left: 0;
          right: 0;
          height: 10px;
          transform: translateY(-50%);
          background: #d91c2b;
        }

        .lgm-uk-red-v {
          left: 50%;
          top: 0;
          bottom: 0;
          width: 10px;
          transform: translateX(-50%);
          background: #d91c2b;
        }

        .lgm-uk-white-d1 {
          background:
            linear-gradient(35deg, transparent 43%, #ffffff 43%, #ffffff 57%, transparent 57%);
        }

        .lgm-uk-white-d2 {
          background:
            linear-gradient(-35deg, transparent 43%, #ffffff 43%, #ffffff 57%, transparent 57%);
        }

        .lgm-uk-red-d1 {
          background:
            linear-gradient(35deg, transparent 47%, #d91c2b 47%, #d91c2b 53%, transparent 53%);
        }

        .lgm-uk-red-d2 {
          background:
            linear-gradient(-35deg, transparent 47%, #d91c2b 47%, #d91c2b 53%, transparent 53%);
        }

        /* Bangladesh Flag */
        .lgm-flag-bd {
          background: #0f7f4f;
        }

        .lgm-bd-base {
          position: absolute;
          inset: 0;
          background: radial-gradient(circle at 30% 28%, rgba(255,255,255,0.18), transparent 32%),
            #0f7f4f;
        }

        .lgm-bd-circle {
          position: absolute;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background: #f11f46;
          top: 50%;
          left: 46%;
          transform: translate(-50%, -50%);
          box-shadow: inset 0 2px 4px rgba(255,255,255,0.08);
        }

        .lgm-lang-text {
          color: #ffffff;
          font-size: 16px;
          line-height: 1.2;
          font-weight: 500;
        }

        @media (max-width: 640px) {
          .lgm-overlay {
            padding: 14px;
          }

          .lgm-modal {
            max-width: 100%;
            border-radius: 24px;
            border-bottom-left-radius: 0;
          }

          .lgm-header {
            height: 50px;
            padding: 0 14px;
          }

          .lgm-title {
            font-size: 15px;
          }

          .lgm-close-btn {
            width: 28px;
            height: 28px;
          }

          .lgm-body {
            gap: 34px;
            padding: 34px 18px 34px;
          }

          .lgm-flag {
            width: 55px;
            height: 55px;
          }

          .lgm-bd-circle {
            width: 36px;
            height: 36px;
          }

          .lgm-lang-text {
            font-size: 14px;
          }
        }
      `}</style>
    </>
  );
}